const MONTH_LABELS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

const DAY_OF_WEEK_LABELS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const DAY_OF_WEEK_SHORT_LABELS = ['S', 'M', 'T', 'W', 'Th', 'F', 'S'];

export const EN_US = {
    months: MONTH_LABELS,
    daysOfWeek: DAY_OF_WEEK_LABELS,
    daysOfWeekShort: DAY_OF_WEEK_SHORT_LABELS,
    statuses: [
        'You can navigate by day using left and right arrows',
        'Weeks by using up and down arrows',
        'Months by using page up and page down keys',
        'Years by using shift plus page up and shift plus page down',
        'Home and end keys navigate to the beginning and end of a week'
    ],
    selectedDate: 'Selected date',
    selectAMonth: 'Select a month.',
    toggleCalendar: 'Toggle calendar',
    backOneYear: 'Navigate back one year',
    backOneMonth: 'Navigate back one month',
    forwardOneYear: 'Navigate forward one year',
    forwardOneMonth: 'Navigate forward one month',
    selectMonth: 'Select month',
    selectYear: 'Select year'
};
